//"use client"

//import * as crypto from 'crypto';
var forge = require('node-forge');

var hex64 = require('hex64');

forge.options.usePureJavaScript = true;



const hexChar = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];


const byteToHex = (b) => hexChar[(b >> 4) & 0x0f] + hexChar[b & 0x0f];

const bytesToHex = (b) => {
    var res = "";
    for (var i = 0; i < b.length; i++)
    {
        res += byteToHex(b.charCodeAt(i));
    }
    return res;
}

const hexToBytes = (hex) => {
  for (var bytes = [], c = 0; c < hex.length; c += 2)
      bytes.push(parseInt(hex.substr(c, 2), 16));
  return bytes;
}

const xor = (b1, b2) => {
  var b3 = [];
  var b4 = "";
  for (var i = 0; i < b1.length; i++)
  {
      var c = b1.charCodeAt(i) & 0xFF;
      var xored = c ^ b2[i];
      b3.push(xored);
      b4 += String.fromCharCode(xored);
  }
  return b4;
}


export const doRSA = (sad, pubkey , algver) => {
  var publicKey = forge.pki.publicKeyFromPem(pubkey);
  var encrypted = publicKey.encrypt(sad, 'RSAES-PKCS1-V1_5');
  var encryptedHex = bytesToHex(encrypted);
  return {
    password: encryptedHex,
    algver
  };
}


export const  genpbkd = ({salt, transid, pass}) => {
  const saltHex = Buffer.from(salt, 'base64').toString('hex')        
  const transidBytes = hexToBytes(hex64.toHex(transid));
  const saltBytes =  forge.util.hexToBytes(saltHex);

  const numIterations = 1000;
  const pbkdkey = forge.pkcs5.pbkdf2(pass, saltBytes, numIterations, 16);
  const sad = xor(pbkdkey, transidBytes);
   
  return sad;
}

export const addSignedHashToDocuments = (signedDocs, documents) => {

  return documents.map(document => {
    const doc = {...document}
    let foundSignedDoc = signedDocs.find(signedDoc => doc.verificationCode === signedDoc.verificationCode)
    
    if (foundSignedDoc) { 
      doc.signedHash = hex64.toHex(foundSignedDoc.signedHash)
      doc.timeStamp = foundSignedDoc.timeStamp 
    }
    return doc
  })
}

export const convertBase64ToHex = (base64) => {
  return hex64.toHex(base64)
}




